import { render, staticRenderFns } from "./FooterProfileComponent.vue?vue&type=template&id=46bf126e&scoped=true&"
import script from "./FooterProfileComponent.vue?vue&type=script&lang=js&"
export * from "./FooterProfileComponent.vue?vue&type=script&lang=js&"
import style0 from "./FooterProfileComponent.vue?vue&type=style&index=0&id=46bf126e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46bf126e",
  null
  
)

export default component.exports